module.exports = __webpack_public_path__ + "media/img/cepik_header-8ebabdc3.png";